import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useContext, useLayoutEffect } from 'react';
import { SharedConfigContext } from '@bepro-travel/fe.shared';
import {
  faPhoneSquare,
  faSquareEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const { footer, siteConfig, imgLogo } = useContext(SharedConfigContext);
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="footer-wrapper">
      <div className="footer">
        <div className="col-md-8 col-12">
          {!!siteConfig && (
            <Fragment>
              <div className="text-lg text-xbold">
                אנחנו כאן כדי ללוות אתכם לאורך כל התהליך, צרו קשר עם מחלקת
                הוויזות שלנו:
              </div>
              <div className="text-bold text-lg">
                {!!siteConfig.phone1 && (
                  <div>
                    <a
                      className="text-lightest pr-10"
                      href={'tel:' + siteConfig.phone1}
                    >
                      {siteConfig.phone1}
                      <FontAwesomeIcon
                        icon={faPhoneSquare}
                        className="ph-10"
                        size="lg"
                      />{' '}
                    </a>
                  </div>
                )}
                {!!siteConfig.phone2 && (
                  <div>
                    <a
                      className="text-lightest pr-10"
                      href={'tel:' + siteConfig.phone2}
                    >
                      {siteConfig.phone2}
                      <FontAwesomeIcon
                        icon={faWhatsapp}
                        className="ph-10"
                        size="lg"
                      />
                    </a>
                  </div>
                )}
                {!!siteConfig.email1 && (
                  <div>
                    <a
                      className="text-lightest pr-10"
                      href={'mailto:' + siteConfig.email1}
                    >
                      {siteConfig.email1}
                      <FontAwesomeIcon
                        icon={faSquareEnvelope}
                        className="ph-10"
                        size="lg"
                      />
                    </a>
                  </div>
                )}
              </div>
            </Fragment>
          )}
        </div>
        {!!footer?.footerPage?.languages?.length && (
          <div
            className="col-md-2 col-12"
            dangerouslySetInnerHTML={{
              __html: footer.footerPage.languages[0].title.body || '',
            }}
          ></div>
        )}
        <div className="col-md-2 col-12">
          <img src={imgLogo} alt="Logo" className="mb-10" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
